// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: 'Poppins', sans-serif;
    background-color: #f0f0f0;
    margin: 0;
}



.card-detail {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    padding: 20px;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.brand {
    display: flex;
    align-items: center;
}

.logo {
    width: 32px;
    height: 32px;
    margin-right: 10px;
}

.brand-name {
    font-size: 18px;
    /* font-weight: ; */
    color: var(--grey-600, rgba(72, 65, 68, 1));
    font-weight: 500;
    font-family: 'Poppins', sans-serif;



}

.view-profile {
    color: rgba(107, 142, 118, 1);
    font-weight: 500;
    font-size: 16px;
    text-decoration: none;
}

.section-title {
    color: rgba(107, 142, 118, 1);
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    font-size: 24px;
    margin-bottom: 10px;
}

.campaign-name {
    font-size: 24px;
    margin-bottom: 5px;
    color: rgba(103, 103, 103, 1);
    font-weight: 500;
}

.campaign-subtitle {
    color: rgba(103, 103, 103, 1);
    font-weight: 400;
    font-size: 20px;
    font-family: 'Poppins', sans-serif;
    margin-bottom: 10px;
    line-height: 31px;
}

.campaign-description {
    margin-bottom: 15px;
    color: rgba(103, 103, 103, 1);
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
}

.campaign-points {
    padding-left: 20px;
    color: rgba(103, 103, 103, 1);
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    margin-top: 10px;
}

.campaign-points li {
    margin-bottom: 10px;
    list-style-type: disc;

}

.compensation-details {
    display: flex;
    align-items: baseline;
    margin-top: 2%;
    margin-bottom: 2%;

}

.compensation-type {
    margin-right: 10px;
    color: rgba(103, 103, 103, 1);
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
}

.compensation-amount {
    font-size: 20px;
    /* font-weight: ; */
    color: rgba(103, 103, 103, 1);
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
}

.info-row {
    display: flex;
    margin-bottom: 10px;
    color: rgba(107, 71, 80, 1);
}

.info-label {
    width: 100px;
    color: rgba(103, 103, 103, 1);
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
}

span.info-value {
    color: rgba(103, 103, 103, 1);
    font-weight: 400;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
}


.timeline {
    color: rgba(103, 103, 103, 1);

}

span.socials-influencer {
    font-weight: 500;
}

.timeline-title {
    font-size: 18px;
    margin-bottom: 10px;
}

.timeline-week {
    margin-bottom: 15px;
}

.week-title {
    font-size: 16px;
    margin-bottom: 5px;
}

.week-tasks {
    padding-left: 20px;
}

.week-tasks li {
    list-style-type: disc;
}

.actions {
    display: flex;
    /* gap: 10px; */
    margin-top: 20px;
}

.btn {
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 16px;
}

button.btn.btn-save {

    border: 1px solid rgba(103, 103, 103, 1);
    margin-right: 2%;
    /* color: white; */
}

button.btn.btn-secondary {
    /* background-color: white; */
    color: var(--secondary-100, rgba(250, 238, 240, 1));
    border: 1px solid #ccc;
    background: rgba(107, 142, 118, 1);
    ;

}

/* .icon {
    margin-right: 5px;
} */

@media (max-width: 600px) {
    .header {
        flex-direction: column;
        align-items: flex-start;
    }

    .view-profile {
        margin-top: 10px;
    }

    .info-row {
        flex-direction: column;
    }

    .actions {
        flex-direction: column;
    }

    .btn {
        width: 100%;
    }
}

/* paymentdashboard */

.payments-dashboard {
    font-family: 'Poppins', sans-serif;
    /* background-color: #fdf8f9; */
    min-height: 100vh;
    padding: 20px;
}

.payments-title {
    color: rgba(107, 71, 80, 1);
    font-family: 'Poppins', sans-serif;
    font-size: 30px;
    font-weight: 500;
    line-height: 45px;


}

.subtitle-container {
    gap: 12px;
}

.subtitle {
    color: rgba(100, 116, 139, 1);
    font-family: 'Poppins', sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;

}

.view-payment-link {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    text-decoration-line: underline;
    text-decoration-style: solid;
}

.search-container {
    position: relative;
    width: 300px;
    margin-right: 10px;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
}

.search-container .search-input {
    width: 100%;
    padding: 10px 10px 10px 40px;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    font-size: 14px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.06);
    border: none !important;
    color: rgba(0, 0, 0, 1);
}

.search-input:focus {
    outline: none;
}

.payments-dashboard .download-btn {
    width: Fixed (251px);
    height: Fixed (50px);
    padding: 8px 12px 8px 12px;
    gap: 10px;
    border-radius: 4px 0px 0px 0px;
    border: 1.5px 0px 0px 0px;
    opacity: 0px;
    color: rgba(107, 71, 80, 1);
    border: 1.5px solid rgba(208, 213, 221, 1)
}

.download-btn:hover {
    background-color: #f9fafb;
}

.table {
    background-color: white;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 20px;
}

.table thead th {
    color: rgba(100, 116, 139, 1);
    font-family: 'Poppins', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
}

.table tbody td {
    color: var(--grey-600, rgba(47, 41, 42, 1));
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
}

.billing-date {
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
}

.rotate-180 {
    transform: rotate(180deg);
}

.status-badge {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
}

.status-badge.paid {
    background-color: #dcfce7;
    color: #15803d;
}

.status-badge.unpaid {
    background-color: #ffe4e6;
    color: #be123c;
}

tr:nth-child(even) {
    background-color: #f9fafb;
}

tr:hover {
    background-color: #f3f4f6;
}

@media (max-width: 768px) {
    .search-container {
        width: 100%;
        margin-bottom: 16px;
    }

    .header {
        flex-direction: column;
    }

    .download-btn {
        width: 100%;
        justify-content: center;
    }
}

/* payment method */

body {
    font-family: 'Poppins', sans-serif;
}

.payments-dashboard .header {
    border-bottom: 2px solid rgba(231, 234, 238, 1);
}

/* Smooth transitions */
.transition-colors {
    transition: all 0.2s ease-in-out;
}

.border.d-inline-flex.align-items-center.justify-content-center.p-3.mb-2 {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: 1px solid #6b8e76 !important;
}

.payment-method-card-body {
    margin: auto;
}

/* Button hover effects */
/* button:hover {
    transform: translateY(-1px);
    transition: transform 0.2s ease;
} */

/* Input placeholder styles */
input::placeholder {
    color: #9ca3af;
}

.border.border-danger.d-inline-flex.align-items-center.justify-content-center.p-3.mb-2 {
    border-radius: 50px;
    width: 70px;
}

.card.p-4 {
    border: 1px dashed;
}

.upi-text,
.text-or,
.text-bank-detail {
    color: rgba(107, 142, 118, 1);
}

p.mb-0.add-bank-text {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 22px;
    line-height: 100%;
    letter-spacing: 0%;
    text-align: center;
    color: rgba(103, 103, 103, 1);
}

/* InfluencerStats */
.content {
    /* margin-left: 5rem !important; */
    margin-bottom: 10px !important;
    padding: 0px 0px !important;
    /* background: var(--Bg, #F9F5F6); */
}

button.MuiButtonBase-root.MuiAccordionSummary-root.MuiAccordionSummary-gutters.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root {
    border: none;
}

.contact-detail {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 22px;
    line-height: 33px;
    letter-spacing: 0px;
}

h3.stats-heading {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 22px;
    line-height: 33px;
    letter-spacing: 0px;

}

.user-name {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: 1px;
    text-align: center;


}

.content::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

.content::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 4px;
}

.content::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}

.content button {
    /* background-color: var(--Bg, #F9F5F6); */
    background-color: none;
    color: var(--quaternary-700, #000);
    font-family: "Poppins", sans-serif;
    margin: 0 1rem;
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    display: flex;
    justify-content: flex-start;
    padding: 1.5rem 0;
    width: fit-content;
    cursor: pointer;
    border: none;
    align-items: center;
}

.content button:hover {
    box-shadow: none;
}

.content button img {
    padding: 0 0.4rem;
    height: 0.8rem;
}

.content .stat-item {
    background-color: #ffffff00;
    display: flex;
    flex-direction: column;
    padding-left: 0.8rem;
    gap: 2rem;
    margin: 1rem;
}

.content .stat-item .contact-container {
    /* background-image: url('../assets/Blender.png'); */
    border-radius: 8px;
    background-color: #fff;
}

.content .stat-item .contact-container .contact {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 1rem;
    padding: 1rem;
}

.content .stat-item .contact-container .contact p {
    color: var(--New-form-color, #6B4750);
    font-family: Poppins;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-align: center;
}

.content .stat-item .contact-container .contact .contact-details {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}

.content .stat-item .contact-container .contact .contact-details .sub-div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 1rem;
}

.content .stat-item .contact-container .contact .contact-details .sub-div small {
    color: var(--grey-500, #50484A);
    font-family: Poppins;
    font-size: 0.98rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
    letter-spacing: 0.16px;
}

.content .stat-item .contact-container .contact .contact-details .sub-div .youtube {
    background-color: red;
    height: 1rem;
    padding: 0.2rem;
    border-radius: 50%;
}

.content .stat-item .contact-container .profile {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.content .stat-item .contact-container .profile h3 {
    color: var(--secondary-400, #6B8E76);
    text-align: center;
    font-family: Poppins;
    font-size: 1.5rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 1px;
}

.content .stat-item .contact-container .profile .image-box {
    margin: 0.2rem;
}

.content .stat-item .contact-container .profile .image-box img {
    margin: 0 0 0.5rem 0;
}

.content .stat-item .contact-container .profile p {
    margin: 0;
    color: var(--secondary-400, #6B8E76);
    text-align: center;
    font-family: Poppins;
    font-size: 1.2rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

@media screen and (max-width: 1028px) {
    .influencer-stats {
        height: 100vh;
        background: var(--Bg, #F9F5F6);
        margin: 0;
        overflow-y: scroll;
        overflow-x: hidden;
        margin-left: 0rem;
    }

    .influencer-stats .wrapper-div .post-interaction {
        display: flex;
        flex-wrap: wrap;
    }

    .influencer-stats .wrapper-div .post-interaction .interaction-stats {
        display: flex;
        justify-content: center;
        gap: 2rem;
        flex-wrap: wrap;
    }

    .influencer-stats .stat-item {
        background-color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        padding: 1rem;
    }

    .influencer-stats .stat-item .contact .contact-details .sub-div small {
        color: var(--grey-500, #50484A);
        font-family: Poppins;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 1rem;
        letter-spacing: 0.16px;
    }
}

@media screen and (max-width: 768px) {
    .parent-box .insta-stats .group-stats {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        margin: 0;
        box-sizing: border-box;
    }
}

@media screen and (max-width: 1028px) {
    .content {
        margin-top: 1.425rem !important;
        margin-left: 0% !important;
    }

    .content .stat-item {
        background-color: #ffffff00;
        display: flex;
        flex-direction: column;
        padding-right: 0rem;
        padding-left: 0rem;
        gap: 2rem;
        margin: 1rem;
    }

    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {
        background: transparent;
        box-shadow: none;
        padding: 0rem;
        padding-right: 0px;
    }
}

/* influencer -profile */
.influ-profile-name {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 48px;
    letter-spacing: 1px;
    text-align: center;
}

h2.title-influ-profile {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 19px;
    line-height: 36px;
    letter-spacing: 0.5px;
}

p.influ-profile-detail {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    letter-spacing: 0.5px;
}

p.influ-profile-location {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 46px;
    letter-spacing: 0.5px;
}

p.influ-profile.bank-detail {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.5px;
}

p.user-bank-detail {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: 0px;
}

p.upi-influ-profile {
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 36px;
    letter-spacing: 0.5px;
}

span.upi-influ-profile.verify {
    color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 26.4px;
    letter-spacing: -1%;
    text-align: center;
}

/* CollaborationModal */
.close-btn {
    border: none;
    background: none;
}

.note-input {
    resize: none;
}

.char-count {
    position: absolute;
    bottom: 5px;
    right: 10px;
    font-size: 12px;
    color: gray;
}

.collab-title.modal-title.h4 {
    color: rgba(0, 0, 0, 0.6);
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: 0%;

}

span.collab-optional {
    color: var(--grey-200, rgba(188, 182, 183, 1));
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 22.5px;
    letter-spacing: 0%;
}

p.collab-body-text {
    color: var(--grey-500, rgba(94, 85, 86, 1));
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 54px;
    letter-spacing: 0%;
    text-align: left;
    /* margin-bottom: 2% !important; */
}

.char-count-outside {
    text-align: right;
    font-size: 14px;
    color: #666;
    margin-top: 5px;
    /* Adjust spacing */
}

button.send-collab-req.btn.btn-light {
    box-shadow: 0 0 0;
    border: none;
    background: transparent;
    text-decoration: underline;
    color: rgba(103, 103, 103, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 18.48px;
    letter-spacing: -1%;
    text-align: center;
    text-decoration-style: solid;
    text-decoration-thickness: Auto;
}

button.send-req.btn.btn-primary {
    background-color: rgba(107, 142, 118, 1);
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 21.12px;
    letter-spacing: -1%;
    text-align: center;
    color: var(--secondary-100, rgba(250, 238, 240, 1));
}

button.btn-close {
    border: none !important;
}

/* second modal */
.success-modal-body {
    background-color: #f8f8f2;
    padding: 40px;
}

.success-icon {
    width: 60px;
    /* Adjust size */
    margin-bottom: 15px;
}

.success-message {
    font-size: 16px;
    color: #567a56;
    font-weight: 500;
}

.error-message {
    color: #ff0000a1;
}




.CardBtn button {
    width: 40%;
}

.CardBtn {
    display: flex;
}


.OngoingShap span {
    width: 15px !important;
    height: 15px !important;
    background-color: #31aa7a;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    display: block;
    margin-right: 5px;
}

.OngoingShap {
    color: #31aa7a !important;
}

.CompletedShap span {
    width: 15px !important;
    height: 15px !important;
    background-color: #E45787;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    display: block;
    margin-right: 5px;
}

.CompletedShap {
    color: #31aa7a !important;
}

.CreatedShap span {
    width: 15px !important;
    height: 15px !important;
    background-color: #676767;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    display: block;
    margin-right: 5px;
}

.CreatedShap {
    color: #676767 !important;
}

.DraftShap span {
    width: 15px !important;
    height: 15px !important;
    background-color: #856FE8;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    display: block;
    margin-right: 5px;
}

.DraftShap {
    color: #856FE8 !important;
}


.status-badge {
    display: flex;
}`, "",{"version":3,"sources":["webpack://./src/InsocialOrbit/Assets/css/influencer.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,SAAS;AACb;;;;AAIA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,kCAAkC;;;;AAItC;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;;AAEzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,kCAAkC;IAClC,eAAe;AACnB;;;AAGA;IACI,6BAA6B;;AAEjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;IAEI,wCAAwC;IACxC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,mDAAmD;IACnD,sBAAsB;IACtB,kCAAkC;;;AAGtC;;AAEA;;GAEG;;AAEH;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,qBAAqB;;AAErB;IACI,kCAAkC;IAClC,+BAA+B;IAC/B,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;;AAGrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,WAAW;IACX,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;IAClC,gDAAgD;IAChD,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,0BAA0B;IAC1B,SAAS;IACT,8BAA8B;IAC9B,yBAAyB;IACzB,YAAY;IACZ,2BAA2B;IAC3B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA,mBAAmB;;AAEnB;IACI,kCAAkC;AACtC;;AAEA;IACI,+CAA+C;AACnD;;AAEA,uBAAuB;AACvB;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA,yBAAyB;AACzB;;;GAGG;;AAEH,6BAA6B;AAC7B;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA,oBAAoB;AACpB;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;;AAEvB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;;;AAGtB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;IAC1C,sBAAsB;IACtB,kCAAkC;IAClC,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,oDAAoD;IACpD,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,8BAA8B;QAC9B,SAAS;QACT,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,aAAa;QACb,mBAAmB;QACnB,6BAA6B;QAC7B,aAAa;IACjB;;IAEA;QACI,+BAA+B;QAC/B,oBAAoB;QACpB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB;QACjB,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,SAAS;QACT,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,+BAA+B;QAC/B,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;QAC3B,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;QACT,YAAY;IAChB;;IAEA;QACI,uBAAuB;QACvB,gBAAgB;QAChB,aAAa;QACb,kBAAkB;IACtB;AACJ;;AAEA,wBAAwB;AACxB;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,0BAA0B;IAC1B,6BAA6B;IAC7B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;;;;AAKA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0FAA0F;IAC1F,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0FAA0F;IAC1F,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0FAA0F;IAC1F,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0FAA0F;IAC1F,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,aAAa;AACjB","sourcesContent":["body {\n    font-family: 'Poppins', sans-serif;\n    background-color: #f0f0f0;\n    margin: 0;\n}\n\n\n\n.card-detail {\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.brand {\n    display: flex;\n    align-items: center;\n}\n\n.logo {\n    width: 32px;\n    height: 32px;\n    margin-right: 10px;\n}\n\n.brand-name {\n    font-size: 18px;\n    /* font-weight: ; */\n    color: var(--grey-600, rgba(72, 65, 68, 1));\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n\n\n\n}\n\n.view-profile {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 500;\n    font-size: 16px;\n    text-decoration: none;\n}\n\n.section-title {\n    color: rgba(107, 142, 118, 1);\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n    font-size: 24px;\n    margin-bottom: 10px;\n}\n\n.campaign-name {\n    font-size: 24px;\n    margin-bottom: 5px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 500;\n}\n\n.campaign-subtitle {\n    color: rgba(103, 103, 103, 1);\n    font-weight: 400;\n    font-size: 20px;\n    font-family: 'Poppins', sans-serif;\n    margin-bottom: 10px;\n    line-height: 31px;\n}\n\n.campaign-description {\n    margin-bottom: 15px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n}\n\n.campaign-points {\n    padding-left: 20px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    margin-top: 10px;\n}\n\n.campaign-points li {\n    margin-bottom: 10px;\n    list-style-type: disc;\n\n}\n\n.compensation-details {\n    display: flex;\n    align-items: baseline;\n    margin-top: 2%;\n    margin-bottom: 2%;\n\n}\n\n.compensation-type {\n    margin-right: 10px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n}\n\n.compensation-amount {\n    font-size: 20px;\n    /* font-weight: ; */\n    color: rgba(103, 103, 103, 1);\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n}\n\n.info-row {\n    display: flex;\n    margin-bottom: 10px;\n    color: rgba(107, 71, 80, 1);\n}\n\n.info-label {\n    width: 100px;\n    color: rgba(103, 103, 103, 1);\n    font-weight: 500;\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n}\n\nspan.info-value {\n    color: rgba(103, 103, 103, 1);\n    font-weight: 400;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n}\n\n\n.timeline {\n    color: rgba(103, 103, 103, 1);\n\n}\n\nspan.socials-influencer {\n    font-weight: 500;\n}\n\n.timeline-title {\n    font-size: 18px;\n    margin-bottom: 10px;\n}\n\n.timeline-week {\n    margin-bottom: 15px;\n}\n\n.week-title {\n    font-size: 16px;\n    margin-bottom: 5px;\n}\n\n.week-tasks {\n    padding-left: 20px;\n}\n\n.week-tasks li {\n    list-style-type: disc;\n}\n\n.actions {\n    display: flex;\n    /* gap: 10px; */\n    margin-top: 20px;\n}\n\n.btn {\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    font-size: 16px;\n}\n\nbutton.btn.btn-save {\n\n    border: 1px solid rgba(103, 103, 103, 1);\n    margin-right: 2%;\n    /* color: white; */\n}\n\nbutton.btn.btn-secondary {\n    /* background-color: white; */\n    color: var(--secondary-100, rgba(250, 238, 240, 1));\n    border: 1px solid #ccc;\n    background: rgba(107, 142, 118, 1);\n    ;\n\n}\n\n/* .icon {\n    margin-right: 5px;\n} */\n\n@media (max-width: 600px) {\n    .header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .view-profile {\n        margin-top: 10px;\n    }\n\n    .info-row {\n        flex-direction: column;\n    }\n\n    .actions {\n        flex-direction: column;\n    }\n\n    .btn {\n        width: 100%;\n    }\n}\n\n/* paymentdashboard */\n\n.payments-dashboard {\n    font-family: 'Poppins', sans-serif;\n    /* background-color: #fdf8f9; */\n    min-height: 100vh;\n    padding: 20px;\n}\n\n.payments-title {\n    color: rgba(107, 71, 80, 1);\n    font-family: 'Poppins', sans-serif;\n    font-size: 30px;\n    font-weight: 500;\n    line-height: 45px;\n\n\n}\n\n.subtitle-container {\n    gap: 12px;\n}\n\n.subtitle {\n    color: rgba(100, 116, 139, 1);\n    font-family: 'Poppins', sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 27px;\n\n}\n\n.view-payment-link {\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 24px;\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n}\n\n.search-container {\n    position: relative;\n    width: 300px;\n    margin-right: 10px;\n}\n\n.search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #666;\n}\n\n.search-container .search-input {\n    width: 100%;\n    padding: 10px 10px 10px 40px;\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n    font-size: 14px;\n    background: rgba(255, 255, 255, 1);\n    box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.06);\n    border: none !important;\n    color: rgba(0, 0, 0, 1);\n}\n\n.search-input:focus {\n    outline: none;\n}\n\n.payments-dashboard .download-btn {\n    width: Fixed (251px);\n    height: Fixed (50px);\n    padding: 8px 12px 8px 12px;\n    gap: 10px;\n    border-radius: 4px 0px 0px 0px;\n    border: 1.5px 0px 0px 0px;\n    opacity: 0px;\n    color: rgba(107, 71, 80, 1);\n    border: 1.5px solid rgba(208, 213, 221, 1)\n}\n\n.download-btn:hover {\n    background-color: #f9fafb;\n}\n\n.table {\n    background-color: white;\n    border-radius: 8px;\n    overflow: hidden;\n    margin-top: 20px;\n}\n\n.table thead th {\n    color: rgba(100, 116, 139, 1);\n    font-family: 'Poppins', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 21px;\n}\n\n.table tbody td {\n    color: var(--grey-600, rgba(47, 41, 42, 1));\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n}\n\n.billing-date {\n    cursor: pointer;\n    user-select: none;\n    display: flex;\n    align-items: center;\n}\n\n.rotate-180 {\n    transform: rotate(180deg);\n}\n\n.status-badge {\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.status-badge.paid {\n    background-color: #dcfce7;\n    color: #15803d;\n}\n\n.status-badge.unpaid {\n    background-color: #ffe4e6;\n    color: #be123c;\n}\n\ntr:nth-child(even) {\n    background-color: #f9fafb;\n}\n\ntr:hover {\n    background-color: #f3f4f6;\n}\n\n@media (max-width: 768px) {\n    .search-container {\n        width: 100%;\n        margin-bottom: 16px;\n    }\n\n    .header {\n        flex-direction: column;\n    }\n\n    .download-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n/* payment method */\n\nbody {\n    font-family: 'Poppins', sans-serif;\n}\n\n.payments-dashboard .header {\n    border-bottom: 2px solid rgba(231, 234, 238, 1);\n}\n\n/* Smooth transitions */\n.transition-colors {\n    transition: all 0.2s ease-in-out;\n}\n\n.border.d-inline-flex.align-items-center.justify-content-center.p-3.mb-2 {\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    border: 1px solid #6b8e76 !important;\n}\n\n.payment-method-card-body {\n    margin: auto;\n}\n\n/* Button hover effects */\n/* button:hover {\n    transform: translateY(-1px);\n    transition: transform 0.2s ease;\n} */\n\n/* Input placeholder styles */\ninput::placeholder {\n    color: #9ca3af;\n}\n\n.border.border-danger.d-inline-flex.align-items-center.justify-content-center.p-3.mb-2 {\n    border-radius: 50px;\n    width: 70px;\n}\n\n.card.p-4 {\n    border: 1px dashed;\n}\n\n.upi-text,\n.text-or,\n.text-bank-detail {\n    color: rgba(107, 142, 118, 1);\n}\n\np.mb-0.add-bank-text {\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 100%;\n    letter-spacing: 0%;\n    text-align: center;\n    color: rgba(103, 103, 103, 1);\n}\n\n/* InfluencerStats */\n.content {\n    /* margin-left: 5rem !important; */\n    margin-bottom: 10px !important;\n    padding: 0px 0px !important;\n    /* background: var(--Bg, #F9F5F6); */\n}\n\nbutton.MuiButtonBase-root.MuiAccordionSummary-root.MuiAccordionSummary-gutters.css-1f1pi2l-MuiButtonBase-root-MuiAccordionSummary-root {\n    border: none;\n}\n\n.contact-detail {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 33px;\n    letter-spacing: 0px;\n}\n\nh3.stats-heading {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 22px;\n    line-height: 33px;\n    letter-spacing: 0px;\n\n}\n\n.user-name {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 32px;\n    line-height: 48px;\n    letter-spacing: 1px;\n    text-align: center;\n\n\n}\n\n.content::-webkit-scrollbar {\n    width: 8px;\n    height: 8px;\n}\n\n.content::-webkit-scrollbar-thumb {\n    background-color: #888;\n    border-radius: 4px;\n}\n\n.content::-webkit-scrollbar-thumb:hover {\n    background-color: #555;\n}\n\n.content button {\n    /* background-color: var(--Bg, #F9F5F6); */\n    background-color: none;\n    color: var(--quaternary-700, #000);\n    font-family: \"Poppins\", sans-serif;\n    margin: 0 1rem;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    display: flex;\n    justify-content: flex-start;\n    padding: 1.5rem 0;\n    width: fit-content;\n    cursor: pointer;\n    border: none;\n    align-items: center;\n}\n\n.content button:hover {\n    box-shadow: none;\n}\n\n.content button img {\n    padding: 0 0.4rem;\n    height: 0.8rem;\n}\n\n.content .stat-item {\n    background-color: #ffffff00;\n    display: flex;\n    flex-direction: column;\n    padding-left: 0.8rem;\n    gap: 2rem;\n    margin: 1rem;\n}\n\n.content .stat-item .contact-container {\n    /* background-image: url('../assets/Blender.png'); */\n    border-radius: 8px;\n    background-color: #fff;\n}\n\n.content .stat-item .contact-container .contact {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin: 1rem;\n    padding: 1rem;\n}\n\n.content .stat-item .contact-container .contact p {\n    color: var(--New-form-color, #6B4750);\n    font-family: Poppins;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    text-align: center;\n}\n\n.content .stat-item .contact-container .contact .contact-details {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n}\n\n.content .stat-item .contact-container .contact .contact-details .sub-div {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n}\n\n.content .stat-item .contact-container .contact .contact-details .sub-div small {\n    color: var(--grey-500, #50484A);\n    font-family: Poppins;\n    font-size: 0.98rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1rem;\n    letter-spacing: 0.16px;\n}\n\n.content .stat-item .contact-container .contact .contact-details .sub-div .youtube {\n    background-color: red;\n    height: 1rem;\n    padding: 0.2rem;\n    border-radius: 50%;\n}\n\n.content .stat-item .contact-container .profile {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.content .stat-item .contact-container .profile h3 {\n    color: var(--secondary-400, #6B8E76);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 1.5rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    letter-spacing: 1px;\n}\n\n.content .stat-item .contact-container .profile .image-box {\n    margin: 0.2rem;\n}\n\n.content .stat-item .contact-container .profile .image-box img {\n    margin: 0 0 0.5rem 0;\n}\n\n.content .stat-item .contact-container .profile p {\n    margin: 0;\n    color: var(--secondary-400, #6B8E76);\n    text-align: center;\n    font-family: Poppins;\n    font-size: 1.2rem;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n}\n\n@media screen and (max-width: 1028px) {\n    .influencer-stats {\n        height: 100vh;\n        background: var(--Bg, #F9F5F6);\n        margin: 0;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        margin-left: 0rem;\n    }\n\n    .influencer-stats .wrapper-div .post-interaction {\n        display: flex;\n        flex-wrap: wrap;\n    }\n\n    .influencer-stats .wrapper-div .post-interaction .interaction-stats {\n        display: flex;\n        justify-content: center;\n        gap: 2rem;\n        flex-wrap: wrap;\n    }\n\n    .influencer-stats .stat-item {\n        background-color: #fff;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-around;\n        padding: 1rem;\n    }\n\n    .influencer-stats .stat-item .contact .contact-details .sub-div small {\n        color: var(--grey-500, #50484A);\n        font-family: Poppins;\n        font-size: 12px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 1rem;\n        letter-spacing: 0.16px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .parent-box .insta-stats .group-stats {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-evenly;\n        margin: 0;\n        box-sizing: border-box;\n    }\n}\n\n@media screen and (max-width: 1028px) {\n    .content {\n        margin-top: 1.425rem !important;\n        margin-left: 0% !important;\n    }\n\n    .content .stat-item {\n        background-color: #ffffff00;\n        display: flex;\n        flex-direction: column;\n        padding-right: 0rem;\n        padding-left: 0rem;\n        gap: 2rem;\n        margin: 1rem;\n    }\n\n    .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiAccordion-root.MuiAccordion-rounded.MuiAccordion-gutters.css-1086bdv-MuiPaper-root-MuiAccordion-root {\n        background: transparent;\n        box-shadow: none;\n        padding: 0rem;\n        padding-right: 0px;\n    }\n}\n\n/* influencer -profile */\n.influ-profile-name {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 48px;\n    letter-spacing: 1px;\n    text-align: center;\n}\n\nh2.title-influ-profile {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    font-size: 19px;\n    line-height: 36px;\n    letter-spacing: 0.5px;\n}\n\np.influ-profile-detail {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 24px;\n    letter-spacing: 0.5px;\n}\n\np.influ-profile-location {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 46px;\n    letter-spacing: 0.5px;\n}\n\np.influ-profile.bank-detail {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 30px;\n    letter-spacing: 0.5px;\n}\n\np.user-bank-detail {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    font-size: 18px;\n    line-height: 30px;\n    letter-spacing: 0px;\n}\n\np.upi-influ-profile {\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 36px;\n    letter-spacing: 0.5px;\n}\n\nspan.upi-influ-profile.verify {\n    color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 26.4px;\n    letter-spacing: -1%;\n    text-align: center;\n}\n\n/* CollaborationModal */\n.close-btn {\n    border: none;\n    background: none;\n}\n\n.note-input {\n    resize: none;\n}\n\n.char-count {\n    position: absolute;\n    bottom: 5px;\n    right: 10px;\n    font-size: 12px;\n    color: gray;\n}\n\n.collab-title.modal-title.h4 {\n    color: rgba(0, 0, 0, 0.6);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 30px;\n    letter-spacing: 0%;\n\n}\n\nspan.collab-optional {\n    color: var(--grey-200, rgba(188, 182, 183, 1));\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 22.5px;\n    letter-spacing: 0%;\n}\n\np.collab-body-text {\n    color: var(--grey-500, rgba(94, 85, 86, 1));\n    font-family: 'Poppins', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 54px;\n    letter-spacing: 0%;\n    text-align: left;\n    /* margin-bottom: 2% !important; */\n}\n\n.char-count-outside {\n    text-align: right;\n    font-size: 14px;\n    color: #666;\n    margin-top: 5px;\n    /* Adjust spacing */\n}\n\nbutton.send-collab-req.btn.btn-light {\n    box-shadow: 0 0 0;\n    border: none;\n    background: transparent;\n    text-decoration: underline;\n    color: rgba(103, 103, 103, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 18.48px;\n    letter-spacing: -1%;\n    text-align: center;\n    text-decoration-style: solid;\n    text-decoration-thickness: Auto;\n}\n\nbutton.send-req.btn.btn-primary {\n    background-color: rgba(107, 142, 118, 1);\n    font-family: 'Poppins', sans-serif;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 21.12px;\n    letter-spacing: -1%;\n    text-align: center;\n    color: var(--secondary-100, rgba(250, 238, 240, 1));\n}\n\nbutton.btn-close {\n    border: none !important;\n}\n\n/* second modal */\n.success-modal-body {\n    background-color: #f8f8f2;\n    padding: 40px;\n}\n\n.success-icon {\n    width: 60px;\n    /* Adjust size */\n    margin-bottom: 15px;\n}\n\n.success-message {\n    font-size: 16px;\n    color: #567a56;\n    font-weight: 500;\n}\n\n.error-message {\n    color: #ff0000a1;\n}\n\n\n\n\n.CardBtn button {\n    width: 40%;\n}\n\n.CardBtn {\n    display: flex;\n}\n\n\n.OngoingShap span {\n    width: 15px !important;\n    height: 15px !important;\n    background-color: #31aa7a;\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n    display: block;\n    margin-right: 5px;\n}\n\n.OngoingShap {\n    color: #31aa7a !important;\n}\n\n.CompletedShap span {\n    width: 15px !important;\n    height: 15px !important;\n    background-color: #E45787;\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n    display: block;\n    margin-right: 5px;\n}\n\n.CompletedShap {\n    color: #31aa7a !important;\n}\n\n.CreatedShap span {\n    width: 15px !important;\n    height: 15px !important;\n    background-color: #676767;\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n    display: block;\n    margin-right: 5px;\n}\n\n.CreatedShap {\n    color: #676767 !important;\n}\n\n.DraftShap span {\n    width: 15px !important;\n    height: 15px !important;\n    background-color: #856FE8;\n    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);\n    display: block;\n    margin-right: 5px;\n}\n\n.DraftShap {\n    color: #856FE8 !important;\n}\n\n\n.status-badge {\n    display: flex;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
